export const BEARER = 'Bearer ';
export const TOKEN_NAME = 'token'